import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { confirmEMail } from "../../services/auth";

const ConfirmEmailPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking);

  const submitHandler = async (e: any) => {
    dispatch(loaderActions.showLoader());
    e.preventDefault();
    const email = e.target[0].value;

    const ignored = ["check24.de", "ab-in-den-urlaub.de", "holidaycheck.de"];

    // Check if the email includes any ignored domain
    if (ignored.some((domain) => email.includes(domain))) {
      console.log("Email is ignored");
      dispatch(loaderActions.hideLoader());
      navigate("/booking-details");
      return;
    }

    try {
      await confirmEMail(email, booking.orgunit, booking.orderId.toString());
      dispatch(loaderActions.hideLoader());
      navigate("/booking-details");
    } catch (err: any) {}
  };

  return (
    <div className="py-10 max-w-2xl mx-auto">
      <h2 className="mb-4">Bitte bestätigen Sie Ihre E-Mail-Adresse</h2>
      <form className="cancellationForm" onSubmit={submitHandler}>
        <div className="mb-3">
          <input
            type="email"
            required
            className="form-control"
            placeholder="Bitte hinterlegen Sie hier Ihre E-Mail-Adresse"
          />
        </div>

        <button type="submit" className="btn btn-warning text-white">
          Senden
        </button>
      </form>
    </div>
  );
};

export default ConfirmEmailPage;
